module.exports = __webpack_public_path__ + "static/cely_rose_bebe_1-2a83bddb623ce22f7a130d801a12f5e6.jpg";